import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import DefaultText from '../../Accessibility/DefaultText';
import DefaultTextBold from '../../Accessibility/DefaultTextBold';
import { ChatTypeEnum } from '../ChatTypeEnum';
import './styles.css';
import { truncateText } from '../../../utils/TextUtils';

const ChatHeader: React.FC<{ chatTitle: string, chatSubtitle: string, chatType: ChatTypeEnum }> = ({ chatTitle, chatSubtitle, chatType }) => {

  const accessibility = useAccessibility();
  const chatContext = chatType === ChatTypeEnum.GC ? '/saudeBemEstar/gestaoDeCronicos' : '/saudeOnline/faleComPersonal';

  const navigate = useNavigate();

  return (
    <div className="chat-header" style={accessibility.contrastStyle}>
      <IconButton
        aria-label="voltar para a lista de conversas"
        onClick={() => navigate(`${chatContext}/conversaEquipe/conversas`)}
        className='chat-back-button'
      >
        <FontAwesomeIcon icon={faChevronLeft} className='fa-icon16x16' color='black' />
      </IconButton>

      <div className='chat-header-infos'>
        <DefaultTextBold text={truncateText(chatTitle, 60)} component="h1" />
        {chatType === ChatTypeEnum.GC && <DefaultText text={chatSubtitle} />}
      </div>

    </div>
  )
}

export default ChatHeader;